import { CardSuggestionTranslationModel } from "@models/card-suggestion-translation.model";
import { BaseConverter } from "./base.converter";
import { CardSuggestionTranslationDto } from "@dtos/card-suggestion-translation.dto";

export class CardSuggestionsTranslationConverter extends BaseConverter <CardSuggestionTranslationModel,CardSuggestionTranslationDto> {

    modelToDto(model: CardSuggestionTranslationModel): CardSuggestionTranslationDto {
        return new CardSuggestionTranslationDto(
            model.title,
            model.location,
            model.details,
            model.link,
            model.locale,    
        );
    }

    dtoToModel(dto: CardSuggestionTranslationDto): CardSuggestionTranslationModel {
        return new CardSuggestionTranslationModel(
            dto.title,
            dto.location,
            dto.details,
            dto.link,
            dto.locale
        );
    }

}